<template>
    <div v-if="!automatic" class="question" :id="item.uuid">
        <!-- <div class="pr-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="var(--primary)" d="M18.59 13H3a1 1 0 0 1 0-2h15.59l-5.3-5.3a1 1 0 1 1 1.42-1.4l7 7a1 1 0 0 1 0 1.4l-7 7a1 1 0 0 1-1.42-1.4l5.3-5.3z"/></svg>
        </div> -->
        <div class="">

            <h2 class="whitespace-pre-line"><span v-if="item.required" class="text-red">* </span>{{ item.title }}</h2>

            <ResponseText
                v-if="item.response_type=='text'"
                :item="item"
            />

            <ResponseNumber
                v-if="item.response_type=='number'"
                :item="item"
            />

            <ResponseCheckbox
                v-if="item.response_type=='checkbox'"
                :item="item"
            />

            <ResponseList
                v-if="item.response_type=='list'"
                :item="item"
                :response-sets="responseSets"
            />

            <ResponseDateTime
                v-if="item.response_type=='datetime'"
                :item="item"
            />

            <ResponseInstruction
                v-if="item.response_type=='instruction'"
                :item="item"
            />

            <ResponseAnnotation
                v-if="item.response_type=='annotation'"
                :item="item"
            />

            <ResponsePhoto
                v-if="item.response_type=='photo'"
                :item="item"
            />

            <ResponseSignature
                v-if="item.response_type=='signature'"
                :item="item"
            />

            <div v-if="showErrors && hasError" class="error-text mt-2 text-red">
                {{ itemErrors.join(', ') }}
            </div>

        </div>

    </div>
</template>

<script>
    import ResponseText from '@/views/ConductInspection/Responses/Text.vue';
    import ResponseNumber from '@/views/ConductInspection/Responses/Number.vue';
    import ResponseCheckbox from '@/views/ConductInspection/Responses/Checkbox.vue';
    import ResponseList from '@/views/ConductInspection/Responses/List.vue';
    import ResponseDateTime from '@/views/ConductInspection/Responses/DateTime.vue';
    import ResponseInstruction from '@/views/ConductInspection/Responses/Instruction.vue';
    import ResponseAnnotation from '@/views/ConductInspection/Responses/Annotation.vue';
    import ResponsePhoto from '@/views/ConductInspection/Responses/Photo.vue';
    import ResponseSignature from '@/views/ConductInspection/Responses/Signature.vue';

    export default {

        components: {
            ResponseText,
            ResponseNumber,
            ResponseCheckbox,
            ResponseList,
            ResponseDateTime,
            ResponseInstruction,
            ResponseAnnotation,
            ResponsePhoto,
            ResponseSignature,
        },

        props: {
            item: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
            showErrors: {
                type: Boolean,
                required: true,
            },
            responseSets: {
                type: Array,
                required: true,
            },
        },
        computed: {
            hasError() {
                return typeof (this.errors[this.item.uuid]) !== 'undefined';
            },
            itemErrors() {
                return this.errors[this.item.uuid];
            },
            automatic() {
                if (this.item.params && this.item.params.automatic === true) {
                    return true;
                }
                return false;
            },
        },

        methods: {},
    };
</script>
